import {
  getImageBase64,
  getBackground,
  getThemePic,
} from "@/views/home/slidePPT/use/methods";
import { pathToBase64 } from "@/utils";

export default async function (data) {
  const node = data.node;
  const catalogueList = node.list || node.children;
  const color = data.color;
  let htmlText = "<ul>";
  for (let i = 0; i < catalogueList.length; i++) {
    const item = catalogueList[i];
    htmlText += `<li style=\"text-align: left;\"><span style=\"font-size: 24.49px;font-family: Microsoft Yahei;\">${item}</span></li>`;
  }
  htmlText += "</ul>";
  const id = Math.random().toString(36).slice(-8);
  const background = await getBackground(data?.customTheme);

  return {
    id: id,
    elements: [
      {
        type: "text",
        id: "FqbLTShHwF",
        left: 83.15,
        top: 127.27,
        width: 600,
        height: 110,
        content: '<p style=""><span style="font-size: 60px;">目录</span></p>',
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
        vertical: false,
      },
      {
        type: "text",
        id: "Q7mjOh-mEO",
        left: 83.15,
        top: 218.19402484055047,
        width: 309.6341054044982,
        height: 80,
        content:
          '<p style=""><span style="font-size: 40px;">CONTENT</span></p>',
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
        vertical: false,
      },
      {
        type: "text",
        id: "FKQsx5EgLg",
        left: 493.4541792547834,
        top: 137.23308734055047,
        width: 361.664988251091,
        height: 241.921875,
        content: htmlText,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
        vertical: false,
      },
    ],
    background,
  };
}
